<div [ngClass]="resizerClass"
     *ngIf="!customHandler">
</div>
<ng-content></ng-content>
